function BootStrapTable({ headers, data }) {
  return (
     
    <div className="table-responsive">
      <table className="table text-center rounded-4 overflow-hidden">
        <thead>
          <tr>
            {headers.map((header, i) => (
              <th scope="col" key={i}>
                {header.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="bg-white text-dark align-middle">
          {data.map((row, i) => (
            <tr key={i}>
              {headers.map((col, j) => (
                <td key={j}>{row[col.accessor]}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
     
  );
}

export default BootStrapTable;

/* 
  const headers = [
    { label: "S No", accessor: "sno" },
    { label: "Exam Name", accessor: "examName" },
    { label: "Subject Name", accessor: "subject" },
    { label: "Class Name", accessor: "class" },
    { label: "Max Marks", accessor: "marks" },
    { label: "Created At", accessor: "created_at" },
    { label: "Actions", accessor: "actions" },
  ];

  const data = [
    {
      sno: 1,
      examName: "Examination Name",
      subject: "English",
      class: "12",
      marks: 85,
      created_at: "2025-07-03",
      actions: <button className="btn btn-sm btn-primary">View</button>,
    },
    {
      sno: 2,
      examName: "Examination Name",
      subject: "Math",
      class: "10",
      actions: <button className="btn btn-sm btn-danger">Delete</button>,
      marks: 100,
      created_at: "2025-07-04",
    },
  ];

*/
